





























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import * as _ from "lodash";
import { PostContents, DeleteContent } from "@/request/projects";
import TemplateTransfer from "./template-transfer.vue";
@Component({
  components: {
    TemplateTransfer,
    ConfirmDialog
  }
})
export default class CdrDetailCustom extends Vue {
  @Prop()
  private name: any;
  @Prop()
  private patient: any;
  @Prop()
  private templateInfo: any;
  @Prop()
  private contents: any;
  private templateStyleObj: any = {
    height: ""
  };
  private cContent: any = {};
  private ifShowConfirm: boolean = false;
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  private get templates() {
    return this.templateInfo["模板"];
  }
  @Watch("contents")
  private contentsChange(contents) {
    if (contents.length > 0) {
      this.cContent = contents[0];
    } else {
      this.cContent = {};
    }
  }
  /**
   * @description 计算滚动内容的高达
   */
  private calHeight() {
    this.templateStyleObj.height =
      (this.$refs.rootWrap as any).offsetHeight - 200 + "px";
  }
  /**
   * @description 切换当前数据
   */
  private changeCurrentContent(c) {
    if (this.ifCompose) {
      this.$message.warning("当前数据尚未保存，请先保存");
      return;
    } else {
      this.cContent = c;
      this.$forceUpdate();
    }
  }
  /**
   * @description 添加
   */
  private add() {
    if (this.ifCompose) {
      this.$message.warning("当前数据尚未保存，请先保存");
      return;
    } else {
      const nDate = new Date();
      const newContent = {
        can_edit: true,
        检测日期:
          "" +
          nDate.getFullYear().toString() +
          "-" +
          (nDate.getMonth() + 1) +
          "-" +
          nDate.getDate(),
        data: _.cloneDeep(this.templates),
        content_id: nDate.getTime().toString() + "new",
        create_time:
          "" +
          nDate.getFullYear().toString() +
          "-" +
          (nDate.getMonth() + 1) +
          "-" +
          nDate.getDate() +
          " " +
          nDate.getHours() +
          ":" +
          nDate.getMinutes() +
          ":" +
          nDate.getSeconds()
      };
      this.cContent = newContent;
      this.contents.unshift(this.cContent);
      this.$store.commit("updateCdrIfCompose", true);
    }
  }
  /**
   * @description 开始删除
   */
  private startDelete() {
    this.ifShowConfirm = true;
  }
  /**
   * @description 删除
   */
  private deleteContent() {
    console.log(this.cContent);
    if (this.cContent.content_id.includes("new")) {
      this.contents.splice(0, 1);
      this.ifShowConfirm = false;
      this.$store.commit("updateCdrIfCompose", false);
    } else {
      const params: any = {
        data: {
          project_id: this.cContent.project_id,
          group_id: this.cContent.group_id,
          patient_id: this.cContent.patient_id,
          content_id: this.cContent.content_id
        }
      };
      DeleteContent(this, params).then(() => {
        this.ifShowConfirm = false;
        this.$emit("refresh");
      });
    }
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    this.$store.commit("updateCdrIfCompose", true);
  }
  /**
   * @description 保存量表数据
   */
  private save() {
    return new Promise((resolve, reject) => {
      // console.log(this.templates);
      const params: any = {
        patient_id: this.patient.patient_id,
        project_id: this.templateInfo.project_id,
        group_id: this.templateInfo.group_id,
        template_id: this.templateInfo.template_id,
        data: this.cContent.data,
        create_time: this.cContent.create_time
      };
      if (this.cContent.content_id.indexOf("new") === -1) {
        params["content_id"] = this.cContent.content_id;
      }
      PostContents(this, params).then((data: any) => {
        this.cContent = data;
        this.$message.success("保存成功");
        this.$store.commit("updateCdrIfCompose", false);
        this.$emit("refresh");
        resolve();
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.calHeight();
    if (this.contents.length > 0) {
      this.cContent = this.contents[0];
    }
  }
}
